export default "__VITE_ASSET__165ba96a__"